import { createFileRoute } from '@tanstack/react-router'

import EditPage from '@/components/pages/backoffice/_klb-penyuluh/_kotakab/containers/EditPage'

export const Route = createFileRoute(
  '/_backoffice/klb-penyuluh/kotakab/$kotakabId/edit'
)({
  component: RouteComponent
})

function RouteComponent() {
  const { kotakabId } = Route.useParams()

  return <EditPage kotakabId={kotakabId} />
}
